import React from 'react';
import * as PropTypes from 'prop-types';
import { AccordionItem as RUIAccordionItem } from '@reach/accordion';

import Content from './content';
import Header from './header';
import useStyles from './styles';

const AccordionItem = (props) => {
    const { item } = props;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <RUIAccordionItem {...props}>
                <Header title={item.title} authors={item.authors} date={item.publishDate} url={item.fullArticleUrl} />
                <Content tags={item.tags} text={item.abstract} url={item.fullArticleUrl} />
            </RUIAccordionItem>
        </div>
    );
};

AccordionItem.propTypes = {
    item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccordionItem;
